import React from "react";
import Toggle from "../Toggle/Toggle";
import "./Navbar.css";
import { Link } from "react-scroll";
const navbar = () => {
  return (
    <div className="n-wrapper" id="Navbar">
      {/* left */}
      <div className="n-left">
        <div className="n-name">Arman</div>
        <Toggle />
      </div>
      {/* right */}
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
            <li>
              <Link activeClass="active" to="Navbar" spy={true} smooth={true}>
                Home
              </Link>
            </li>
            <li>
              <Link to="services" spy={true} smooth={true}>
                Serivces
              </Link>
            </li>
            <li>
              <Link to="works" spy={true} smooth={true}>
                Experience
              </Link>
            </li>
            <li>
              <Link to="portfolio" spy={true} smooth={true}>
                Protfolio
              </Link>
            </li>
            <li>
              <Link to="testimonial" spy={true} smooth={true}>
                Testimonial
              </Link>
            </li>
          </ul>
        </div>
        <Link to="contact" spy={true} smooth={true}>
        <button className="button n-button">Contact</button>
        </Link>
      </div>
    </div>
  );
};

export default navbar;


// import React from 'react'
// import './Navbar.css'

// const Navbar = () => {
//   return (
//     <div className='n-wrapper'>
//         <div className='n-left'>
//             <div className='n-name'>Arman</div>
//             <span>toggle</span>
//         </div>
    
//         <div className='n-right'>
//             <div className='n-list'>
//                 <ul style={{listStyleType: 'none'}}>
//                     <li>Home</li>
//                     <li>Sevice</li>
//                     <li>Experience</li>
//                     <li>Portfolio</li>
//                     <li>Testimonials</li>
//                 </ul>
//             </div>
//             <button className="button n-button">Contact</button>
//         </div>
//     </div>
//   )
// }

// export default Navbar